<template>
    <div v-if="hasAccess">
        <top-nav-bar goto="/">
            <router-link to="/leaves/create" tag="button"
                         class="h-full items-center flex bg-secondary absolute pin-t pin-r mr-2 text-white font-bold font-heading uppercase">
                <i class="fas fa-plus mr-2"></i>
                Add Leave
            </router-link>
        </top-nav-bar>

        <list v-if="leaves.length">
            <list-item class="text-base sm:text-xl"
                       v-for="leave in leaves"
                       url="#"
                       :key="leave.id"
                       @click.native.prevent
                       @click="navigateTo(leave)">
                <template slot="icon">
                    <span class="text-center w-full">
                        <i class="fa" :class="findObjectStatusIconStyles(leave.status)"></i>
                    </span>
                </template>
                <template slot="title">
                    <span class="relative">
                        {{leave.subtype.name}}
                        <small class="font-normal">{{leave.percentageReadable ? `${leave.percentageReadable}` : ''}}</small>
                        <span class="h-4 flex -mr-4 absolute pin-t pin-r items-center justify-center bg-red rounded-full text-white text-xs px-1"
                              v-if="$hasNotification('leaves', leave.id).length > 0"
                              v-text="$hasNotification('leaves', leave.id).length"></span>
                    </span>
                </template>
                <template slot="sub-title">
                    {{formatDate(leave.start, 'D MMM YYYY') + (leave.end ? (' - ' + formatDate(leave.end, 'D MMM YYYY')) : '')}}
                </template>
                <template slot="status">
                    <span class="font-heading uppercase text-xs font-bold"
                          :class="findObjectStatusStyles(leave.status)">
                        {{leave.status.status}}
                    </span>
                </template>
            </list-item>
        </list>

        <empty :visible="!leaves.length">
            You have not submitted any leaves.
        </empty>
    </div>
</template>

<script>
    import InteractsWithDates from '@/mixins/InteractsWithDates'
    import CanAccessView from '../mixins/CanAccessView';
    import ShowObjectStatus from '../mixins/ShowObjectStatus';

    export default {
        mixins: [InteractsWithDates, ShowObjectStatus, CanAccessView],

        data() {
            return {
                loading: true,
                leaves: []
            }
        },

        computed: {},

        mounted() {
            this.$api('leave-tracker/pub').get('')
                .then(({data}) => {
                    this.leaves = data.data;
                    this.loading = false;
                })
        },

        methods: {

            navigateTo(leave) {
                this.processNotifications(leave);
                this.$router.push('/leaves/' + leave.id)
            },

            processNotifications(leave) {
                let notifications = this.$hasNotification('leaves', leave.id);

                if (notifications.length > 0) {
                    notifications.forEach(notification => this.$notificationRead(notification));
                }
            }
        },
    }
</script>
